export default __webpack_public_path__ + "static/media/icon-notfound.aff8ae1e.svg";